<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"
                >Next {{ $t('Upload-Ticket') }}</v-toolbar-title
              >
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row="" wrap="">
              <a target="_self" v-bind:href="'https://download.arkman.com.tr/SetupTicketUpload.rar'">
              <v-btn style="width:200px" color="info" dark
                >Rar indir
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              </a>
              

              <a target="_self" v-bind:href="'https://download.arkman.com.tr/SetupTicketUpload.msi'"> 
              <v-btn style="width:200px" color="info"  dark
                >Exe İndir
                <v-icon right="" dark>cloud_download</v-icon>
              </v-btn>
               </a>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../api/auth";

import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";

export default {
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    yetkidialog,
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              let url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              let url = "#/";
              window.open(url, "_self");
            }
          }
        });
    }
  },
  watch: {
    search(val) {
      val && this.carigetir(val);
    },
  },
  filters: {
    dateformat: function(t) {
      return helpers.dateformat(t);
    },
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function(m) {
      return helpers.bakiyekontrol(m);
    },
  },
  methods: {

  },
};

function beforeMount() {}
</script>

<style></style>
